import classNames from "classnames";

export type SkeletonShape = "rect" | "circle" | "text";

interface SkeletonProps {
    shape?: SkeletonShape;
    className?: string;
    "data-testid"?: string;
}

const SHAPE_CLASS: Record<SkeletonShape, string> = {
    rect: "rounded",
    circle: "rounded-full",
    text: "h-3 rounded",
};

export const Skeleton = ({
    shape = "rect",
    className,
    "data-testid": testId,
}: SkeletonProps) => {
    return (
        <div
            data-testid={testId}
            aria-hidden="true"
            className={classNames(
                "bg-base-300 animate-pulse",
                SHAPE_CLASS[shape],
                className,
            )}
        />
    );
};
